import { Logger } from '@ori/logger';
import { PACKAGE_NAME, TEAM_NAME } from './constants-generated';
export const mainLogger = new Logger(PACKAGE_NAME, {
    teamName: TEAM_NAME
});
export const mypagesMainLogger = new Logger(PACKAGE_NAME, {
    part: 'mypages',
    teamName: TEAM_NAME
});
export const onlyHeaderMainLogger = new Logger(PACKAGE_NAME, {
    part: 'onlyHeader',
    teamName: TEAM_NAME
});
export const personalizedNutritionMainLogger = new Logger(PACKAGE_NAME, {
    part: 'personalized-nutrition',
    teamName: TEAM_NAME
});
export const supportCenterMainLogger = new Logger(PACKAGE_NAME, {
    part: 'support-center',
    teamName: TEAM_NAME
});
export const mobileAppsMainLogger = new Logger(PACKAGE_NAME, {
    part: 'mobile-apps',
    teamName: TEAM_NAME
});
export const reportAConcernMainLogger = new Logger(PACKAGE_NAME, {
    part: 'report-a-concern',
    teamName: TEAM_NAME
});
export const talksMainLogger = new Logger(PACKAGE_NAME, {
    part: 'talks',
    teamName: TEAM_NAME
});
export const shareAndEarnMainLogger = new Logger(PACKAGE_NAME, {
    part: 'share-and-earn',
    teamName: TEAM_NAME
});
